import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { ProductCardsForm } from './product-cards-form';

type ProductCardsProps = {
  /** See ProductCardsFormProps.mobileOnly. */
  mobileOnly?: boolean;
};

export function ProductCards({ mobileOnly }: ProductCardsProps = {}): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <ProductCardsForm data={data} mobileOnly={mobileOnly} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
